import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const GameExpectationsSubForm = loadable(() =>
  withDefaultLoaderModifiers(import("./GameExpectationsSubForm"))
);
